// ABOUTME: The license purchase dialog (DVLP-7860). One footprint for every step:
// ABOUTME: Choose, Pay, Processing and the outcome all render in the same fixed-height box.
import { observer } from 'mobx-react';
import { Modal, ModalBody, emptyFragment } from '@execonline-inc/execonline-ui';
import Socket from '../../../../../Socket';
import WithPusherSettings from '../../../../../ToolingsStore/WithPusherSettings';
import licensePurchaseStore from '../Store';
import ChooseLicense from './ChooseLicense';
import PayForLicense from './PayForLicense';
import ProcessingPurchase from './ProcessingPurchase';
import { LicensePurchased, PurchaseFailed } from './PurchaseOutcome';

/**
 * One fixed size at md and up, so going from Choose to Pay reads as the same task
 * continuing rather than a new dialog. The height is set on the dialog panel, not
 * the body: ModalBody is `flex-1`, and in a flex column a flex basis overrides
 * `height`, which is why a height on the body let each step size the box. Content
 * that does not fit scrolls inside its own pane. Below md the dialog takes the
 * screen, as the course checkout does.
 */
const PANEL_CLASS =
  'h-full rounded-none sm:h-auto md:h-[min(44rem,calc(100vh-2rem))] [&_button]:font-sans';
const BODY_CLASS = 'flex min-h-0 flex-col overflow-hidden p-0 sm:p-0 md:flex-row';

function Body() {
  const flow = licensePurchaseStore.flow;
  switch (flow.kind) {
    case 'closed': {
      return emptyFragment();
    }
    case 'choosing': {
      return <ChooseLicense flow={flow} />;
    }
    case 'starting-purchase':
    case 'paying': {
      return <PayForLicense flow={flow} />;
    }
    case 'processing': {
      return <ProcessingPurchase flow={flow} />;
    }
    case 'purchased': {
      return <LicensePurchased flow={flow} />;
    }
    case 'failed': {
      return <PurchaseFailed flow={flow} />;
    }
  }
}

function LicensePurchaseModal() {
  const flow = licensePurchaseStore.flow;
  // The card is charged and the license is being created: no close, no escape,
  // no click-away. Someone who leaves here concludes the payment failed.
  const exitable = flow.kind !== 'processing';

  return (
    <Modal
      className={PANEL_CLASS}
      open={flow.kind !== 'closed'}
      size="4xl"
      escapeKey={exitable}
      outsidePress={exitable}
      classNames={{ closeButton: exitable ? undefined : 'hidden' }}
      onClose={licensePurchaseStore.close}
    >
      <ModalBody className={BODY_CLASS} data-intercom-target="license-purchase-dialog">
        <WithPusherSettings>
          {(pusherSettingsResource) => (
            <Socket pusherSettingsResource={pusherSettingsResource}>
              <Body />
            </Socket>
          )}
        </WithPusherSettings>
      </ModalBody>
    </Modal>
  );
}

export default observer(LicensePurchaseModal);
